import React from 'react'

import { PasswordResetRequest } from '../components/PasswordResetRequest'
import { AkaTypography } from '../../../components'
import {
	AuthWrapper,
	Headline,
	StyledContent,
	StyledLink
} from '../components/styles'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '../../navigation'
import PublicLayout from '../../publicLayout/containers/PublicLayout'

/**
 * PasswordResetRequestPage Component
 *
 * This component renders the password reset request page.
 * It includes:
 * - A layout wrapper
 * - A header with the company logo
 * - Content including a headline and the password reset request form
 * - A link to navigate back to the login page
 *
 * It uses:
 * - `useTranslation` for localizing the text
 * - Routing to link back to the login page
 */
const PasswordResetRequestPage = () => {
	const [t] = useTranslation()

	return (
		<PublicLayout>
			<StyledContent>
				<AuthWrapper>
					<Headline>
						<AkaTypography variant="bodySegoe">
							{t('auth.passwordRequestPage.headline')}
						</AkaTypography>
					</Headline>
					<PasswordResetRequest />
				</AuthWrapper>
				<StyledLink to={ROUTES.login}>
					<AkaTypography
						gutterbottom={0}
						variant={'bodySegoe'}
						color={'primary'}
					>
						{t('auth.backToLogin')}
					</AkaTypography>
				</StyledLink>
			</StyledContent>
		</PublicLayout>
	)
}

export default PasswordResetRequestPage
